import { Controller } from "@hotwired/stimulus"

// A trigger button opening a small flyout of actions (the template card's
// new-file-layout start menu). Sections hidden by default can be
// revealed from within the menu (the type-ahead for "another file layout"),
// and a hidden-field change submits its surrounding form (a combobox pick).
// Closes on outside click or Escape.
export default class extends Controller {
  static targets = ["menu", "section"]

  connect() {
    this.onDocClick = this.onDocClick.bind(this)
    this.onKeydown = this.onKeydown.bind(this)
    document.addEventListener("click", this.onDocClick)
    document.addEventListener("keydown", this.onKeydown)
  }

  disconnect() {
    document.removeEventListener("click", this.onDocClick)
    document.removeEventListener("keydown", this.onKeydown)
  }

  // The click must keep bubbling to the document: that is what closes every
  // OTHER open flyout (their own outside-click handler). The row-link ignores
  // button clicks, so no stopPropagation is needed here.
  toggle() {
    this.menuTarget.hidden ? this.open() : this.close()
  }

  open() {
    this.menuTarget.hidden = false
    this.setExpanded(true)
  }

  close() {
    this.menuTarget.hidden = true
    this.sectionTargets.forEach((section) => { section.hidden = true })
    this.setExpanded(false)
  }

  reveal(event) {
    event.stopPropagation()
    this.sectionTargets.forEach((section) => { section.hidden = false })
    const field = this.sectionTargets[0]?.querySelector("input:not([type=hidden])")
    if (field) field.focus()
  }

  submitOnPick(event) {
    if (event.target.value) event.target.form.requestSubmit()
  }

  setExpanded(open) {
    const trigger = this.element.querySelector("[aria-haspopup]")
    if (trigger) trigger.setAttribute("aria-expanded", open ? "true" : "false")
  }

  onDocClick(event) {
    if (!this.element.contains(event.target)) this.close()
  }

  onKeydown(event) {
    if (event.key === "Escape") return this.close()
    if (this.menuTarget.hidden) return
    if (event.key !== "ArrowDown" && event.key !== "ArrowUp") return
    if (!this.element.contains(document.activeElement)) return

    event.preventDefault()
    const items = Array.from(this.menuTarget.querySelectorAll("[role='menuitem']"))
    if (items.length === 0) return
    const step = event.key === "ArrowDown" ? 1 : -1
    const index = items.indexOf(document.activeElement)
    items[(index + step + items.length) % items.length].focus()
  }
}
